import React from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import { Row, Col, Label, Input, InputGroup } from "reactstrap";
import Select from "react-select";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import { templateHelper } from "../../../template/helpers/templateHelper";
import { emailActions } from "../../../../../store/actions/cms/email/email.action";
import { setValueToNestedObject, deepClone } from "../../../../../helpers/objectHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import { UseTemplateButton, SetStyleToAllOfItsType, SetToAuto } from "../../components/UseTemplateButton";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { UrlMultiInput } from "../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import { emailFonts } from "../../models/emailFonts/emailFonts";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { emailHelper } from "../../helper/email.helper";
import InheritageButtonGroup from "../../../../components/editor/tools/Inheritage/InheritageButtonGroup";
import JirangoSwitch from "../../../../../components/UI/Switch/JirangoSwitch";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

class EmailSettings extends React.Component {
  state = {
    spreadActiveSet: [],
  };
  componentDidMount() {
    const { dispatch, cms } = this.props;
    dispatch(templateActions.getAll(cms.eventId, true));
  }
  componentDidUpdate(prevProps) {
    const { email, dispatch } = this.props;
    if (this.props.template !== undefined && prevProps.template.templateId !== this.props.template.templateId) {
      const newElements = emailHelper.handleTemplateStyleInheritage(this.props.email.elements, this.props.template);
      dispatch(emailActions.updateEmailElement(newElements, null, true, this.props.inherit));
    }
  }
  handleSoftUpdate = (email) => {
    const { dispatch } = this.props;
    dispatch(emailActions.softUpdate(email));
  };
  toggleInheritageStatus = (status) => {
    const { dispatch } = this.props;
    const email = deepClone(this.props.email);
    email.inherit = status;
    email.isSavable = true;
    dispatch(emailActions.softUpdate(email));
  };
  toggleLinktracking = (on) => {
    const { dispatch } = this.props;
    const email = deepClone(this.props.email);
    email.useLinktrack = on;
    console.log("onChange", on, email);
    dispatch(emailActions.softUpdate(email));
  };
  handleChange = (e, val, path) => {
    const { email } = this.props;
    let emailCopy = deepClone(email);
    emailCopy[path] = val;
    this.handleSoftUpdate(emailCopy);
    if (path === "templateId") {
      this.props.dispatch(templateActions.get(val));
    }
  };
  render() {
    const { email, templates, template } = this.props;
    const selectStyles = {
      option: (styles, { data }) => {
        return {
          ...styles,
          fontSize: "15px",
          fontFamily: data.value,
          padding: "10px 10px",
        };
      },
      control: (provided, state) => ({
        ...provided,
        maxWidth: "100%",
        width: "auto",
      }),
      container: (styles) => ({
        ...styles,
        width: "100%",
        borderRight: "1px solid gainsboro",
      }),
    };
    return (
      <React.Fragment>
        <ListExpansion footer={false} icon="fa fa-image" description="Email" defaultExpanded={true}>
          <Row style={{ display: "block", marginBottom: "10px", marginLeft: "-5px" }}>
            <Col>
              <Label>
                <SystemLabel name="Name" />
              </Label>
            </Col>
            <Col>
              <Input maxLength="255" value={email.name || ""} onChange={(e) => this.handleChange(null, e.target.value, "name")} />
            </Col>
          </Row>
          <Row style={{ display: "block", marginBottom: "10px", marginLeft: "-5px" }}>
            <Col>
              <Label>
                <SystemLabel name="Subject" />
              </Label>
            </Col>
            <Col>
              <Input maxLength="255" value={email.subject || ""} onChange={(e) => this.handleChange(null, e.target.value, "subject")} />
            </Col>
          </Row>
          <Row style={{ display: "block", marginBottom: "10px", marginLeft: "-5px" }}>
            <Col>
              <Label>
                <SystemLabel name="PreviewText" />
              </Label>
            </Col>
            <Col>
              <Input maxLength="100" type="textarea" style={{ minHeight: "220px" }} value={email.previewText || ""} onChange={(e) => this.handleChange(null, e.target.value, "previewText")} />
            </Col>
          </Row>
          <Row style={{ display: "block", marginBottom: "10px", marginLeft: "-5px" }}>
            <Col>
              <Label>
                <SystemLabel name="FromName" />
              </Label>
            </Col>
            <Col>
              <Input maxLength="100" value={email.fromName || ""} onChange={(e) => this.handleChange(null, e.target.value, "fromName")} />
            </Col>
          </Row>
          <Row style={{ display: "block", marginBottom: "10px", marginLeft: "-5px" }}>
            <Col>
              <Label>
                <SystemLabel name="FromAddress" />
              </Label>
            </Col>
            <Col>
              <Input maxLength="100" value={email.fromAddr || ""} onChange={(e) => this.handleChange(null, e.target.value, "fromAddr")} />
            </Col>
          </Row>
          <Row style={{ display: "block", marginBottom: "10px", marginLeft: "-5px" }}>
            <Col>
              <Label>
                <SystemLabel name="Bcc" />
              </Label>
            </Col>
            <Col>
              <Input value={email.bcc || ""} onChange={(e) => this.handleChange(null, e.target.value, "bcc")} />
            </Col>
          </Row>
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="Template" />
              </Label>
            </Col>
          </Row>
          <Row>
            <Col className="list-setting-item-title" style={{ lineHeight: "unset" }}>
              <InputGroup style={{ display: "inline-flex", flexWrap: "nowrap", alignItems: "unset", maxWidth: "100%" }}>
                <Select
                  classNamePrefix="jirango-select"
                  className="jirango-select"
                  options={templates.map((t) => {
                    return {
                      value: t.templateId,
                      label: t.name,
                    };
                  })}
                  value={template.templateId ? { label: template.name, value: template.templateId } : null}
                  onChange={(selectedOption) => this.handleChange(null, selectedOption.value, "templateId")}
                  styles={selectStyles}
                />
                <button
                  onClick={() => {
                    window.open(
                      window.location.host?.includes("localhost") ? `https://localhost:44331/Template/List?eventId=${this.props?.cms?.eventId}` : `https://jirango.com/Template/List?eventId=${this.props?.cms?.eventId}`,
                      "_blank"
                    );
                  }}
                  style={{ backgroundColor: "transparent", border: 0, color: '#222' }}
                >
                  <OpenInNewIcon />
                </button>
              </InputGroup>
            </Col>
          </Row>
          <br />
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="UseLinktracking" />
              </Label>
            </Col>
            <Col style={{ textAlign: "right" }}>
              <JirangoSwitch onChange={(e) => this.toggleLinktracking(!email.useLinktrack)} isChecked={email.useLinktrack !== true ? false : true} />
            </Col>
          </Row>
        </ListExpansion>
        <br />
        <ListExpansion footer={false} icon="fa fa-square" defaultExpanded={true} description="Inheritage">
          <InheritageButtonGroup onClick={this.toggleInheritageStatus} status={email.inherit} />
        </ListExpansion>
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    email: state.email,
    template: state.template.template,
    inherit: state.email.inherit,
    templates: state.template.templates,
    cms: state.cms,
  };
}
export default connect(mapStateToProps)(EmailSettings);
